<template>
  <div class="storefinder-map-marker" v-show="false">
    <div class="infoWindow" ref="info" >
      <slot name="infoWindow"></slot>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default {
    name: 'storefinder-map-marker',
    data() {
      return {
        icon: null,
        marker: null,
        infoWindow: null,
        map: null
      };
    },
    props:{
      image:{
        type: Object
      },
      store: {
        type: Object,
        required: true,
      }
    },
    inject: ['getMap', "addMarker", "removeMarker"],
    mounted(){
      this.getMap(({ google, map })=>{
        if(this.image.src){
          this.icon =  new google.maps.MarkerImage(this.image.src, null, null, null, new google.maps.Size(this.image.width, this.image.height));
        }
        const marker =  new google.maps.Marker({
          title: this.store.company,
          icon: this.icon ? this.icon : null,
          position: {
            lat: parseFloat(this.store.latitude),
            lng: parseFloat(this.store.longitude),
          },
          animation: google.maps.Animation.DROP,
        });
        if(this.$slots.infoWindow ){
          const infoWindow = new google.maps.InfoWindow({
            content: this.$refs.info.outerHTML
          });
          marker.addListener('click',  this.openWindow);
          this.infoWindow = infoWindow;
        }
        this.marker = marker;
        this.map = map;
        this.addMarker(this.marker)
      });
    },
    beforeDestroy(){
      this.removeMarker(this.marker)
    },
    methods: {
      openWindow(){
        this.stores.forEach((store)=>{
          if(store.uid !== this.store.uid){
            store.selected = false;
          }
        })
        this.store.selected = true;
        this.infoWindow.open(this.map, this.marker);
      }
    },
    computed: {
      ...mapGetters(["stores"]),
    },
    watch:{
      'store.selected'(val){
        if(val){
          this.openWindow();
        } else {
          this.infoWindow.close();
        }
      }
    }
  };
</script>